import { computed, inject } from '@angular/core';
import { pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { DepartmentService } from './department.service';
import { type DepartmentDetails } from '../../types';
import { patchState, signalStore, withComputed, withHooks, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import {
  setError,
  setLoaded,
  setLoading,
  setResetState,
  withCallState,
  withReset,
  withStorageSync,
} from '@ngrx-toolkit/core';

type State = {
  details: DepartmentDetails | null;
};

const initialState: State = {
  details: null,
};

export const DepartmentStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCallState(),
  withReset(),
  withComputed(({ details }) => ({
    departmentId: computed(() => details()?.departmentId),
    governmentId: computed(() => details()?.governmentId),
    isAransasDepartment: computed(() => details()?.governmentId === 'TX0040100'),
    isBrooksDepartment: computed(() => details()?.governmentId === 'TX0240000'),
    isBrownsvilleDepartment: computed(() => details()?.governmentId === 'TX0310100'),
  })),
  withStorageSync('td:department'),
  withMethods((store, api = inject(DepartmentService)) => ({
    load: rxMethod<string>(
      pipe(
        tap(() => patchState(store, setLoading())),
        switchMap((id) =>
          api.load(id).pipe(
            tapResponse({
              next: (details) => patchState(store, { details }, setLoaded()),
              error: (error) => patchState(store, setError(error)),
            }),
          ),
        ),
      ),
    ),
  })),
  withHooks({
    onInit(store) {
      setResetState(store, initialState);
    },
  }),
);
